export default __webpack_public_path__ + "static/media/custoBaixo.3868032e.png";